module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-x-fill-f247abbc.svg";